<template>
  <div class="modal-dialog">
    <div class="modal-content global-site-settings-pop-up">
      <div class="modal-body">
        <button type="button" class="close resource-close" @click="closeModal()" data-dismiss="modal">
          &times;
        </button>
        <div class="row">
          <div class="col-md-12 col-sm-12 col-lg-12">
            <span class="global-settings-title">Global Site Settings</span>
          </div>
          <div class="col-md-12 col-sm-12 col-lg-12 pt-10">
            <span>Configure the ability for all sites to manage site documents and add participants. These features can also be configured at the individual site level. </span>
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-md-8 col-sm-8 col-lg-8">
            <span class="global-settings-text">Allow uploading and configuring of site documents</span>
          </div>
          <div class="col-md-4 col-sm-4 col-lg-4">
            <div class="switch-button pt-4 col-md-12">
              <label class="switch-toggle-btn">
                <input type="checkbox" v-model="canSiteTeamAddDocuments" :disabled="canSupportAccess" />
                <div :class="canSupportAccess ? 'slider slider-disabled' : 'slider'"></div>
                <div class="text"></div>
              </label>
            </div>
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-md-8 col-sm-8 col-lg-8">
            <span class="global-settings-text">Allow the ability to add participants</span>
          </div>
          <div class="col-md-4 col-sm-4 col-lg-4">
            <div class="switch-button pt-4 col-md-12">
              <label class="switch-toggle-btn">
                <input type="checkbox" v-model="canSiteTeamAddParticipant" :disabled="canSupportAccess" />
                <div :class="canSupportAccess ? 'slider slider-disabled' : 'slider'"></div>
                <div class="text"></div>
              </label>
            </div>
          </div>
        </div>
        <hr />
        <div class="row" v-if="canSysAdminAccess || canSupportAccess">
          <div class="col-md-8 col-sm-8 col-lg-8">
            <span class="global-settings-text">Allow downloading esource documents</span>
          </div>
          <div class="col-md-4 col-sm-4 col-lg-4">
            <div class="switch-button pt-4 col-md-12">
              <label class="switch-toggle-btn">
                <input type="checkbox" v-model="canSiteTeamDownloadEsourceDocs" :disabled="canSupportAccess" />
                <div :class="canSupportAccess ? 'slider slider-disabled' : 'slider'"></div>
                <div class="text"></div>
              </label>
            </div>
          </div>
        </div>
        <hr v-if="canSysAdminAccess || canSupportAccess" />
        <div class="row right-align pt-10">
          <b-btn variant="primary" class="create-btn2 save-button fs-12 mr-12" @click="closeModal()" data-dismiss="modal" v-if="canSupportAccess">Close</b-btn>
          <b-btn variant="primary" class="create-btn2 save-button fs-12 mr-12" @click="saveSiteGlobalSettings()" v-else>Save</b-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SYSTEM_ADMIN, SUPPORT } from "@/constants/authRoles";
import { mapGetters } from "vuex";
import { AclRule } from "vue-acl";
export default {
  name: "GlobalSiteSettingsPopup",
  data() {
    return {
      canSiteTeamAddParticipant: true,
      canSiteTeamAddDocuments: true,
      canSiteTeamDownloadEsourceDocs: false
    };
  },
  computed: {
    ...mapGetters(["user"]),
    studyId() {
      return this.$route.params.studyId;
    },
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    canSysAdminAccess() {
      this.$acl.change(`${SYSTEM_ADMIN}`);
      return this.$acl.check("userAccess");
    },
    canSupportAccess() {
      this.$acl.change(`${SUPPORT}`);
      return this.$acl.check("userAccess");
    }
  },
  methods: {
    saveSiteGlobalSettings() {
      this.$api.saveGlobalSiteSetting(this.studyId, this.canSiteTeamAddParticipant, this.canSiteTeamAddDocuments, this.canSiteTeamDownloadEsourceDocs).then(
        response => {
          if (response) {
            window.$("#global-site-settings-popup").modal("hide");
            this.$toastr.success("Global site settings saved successfully.");
            this.getGlobalSiteSetting();
          }
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while saving global settings.");
        }
      );
    },
    getGlobalSiteSetting() {
      this.$api.getGlobalSiteSettings(this.studyId).then(
        response => {
          if (response.body) {
            this.canSiteTeamAddParticipant = response.body.AddParticipantGlobalSettingEnabledFlag;
            this.canSiteTeamAddDocuments = response.body.DocumentGlobalSettingEnabledFlag;
            this.canSiteTeamDownloadEsourceDocs = response.body.DownloadEsourceDocsEnabledFlag;
          }
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting global settings.");
        }
      );
    },
    closeModal() {
      this.getGlobalSiteSetting();
    }
  },
  mounted() {
    this.getGlobalSiteSetting();
  }
};
</script>

<style lang="scss" scoped>
.global-site-settings-pop-up {
  width: 580px;
  margin: 0 0 3.1px;
  border-radius: 4px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
}
.global-settings-title {
  font-size: 18px;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.28;
  letter-spacing: normal;
  text-align: left;
  color: #666669;
}
.modal-body {
  padding: 1.5rem;
}
.save-button {
  width: 94px;
  height: 35px;
  margin: 0 0 0 30.3px;
  border-radius: 4px;
  background-color: #4c8ce4;
}
.right-align {
  float: right;
}
.global-settings-text {
  font-weight: 700;
}
/*toggle btn css*/
.switch-toggle-btn {
  position: relative;
  display: inline-block;
  width: 100px;
  height: 24px;
  font-size: 14px;
  top: -2px;
  left: 10px;
}
.switch-toggle-btn input {
  opacity: 0;
}

.switch-toggle-btn .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #e0e0e0;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 15px;
}

.switch-toggle-btn .slider:before {
  position: absolute;
  content: "";
  height: 21px;
  width: 21px;
  left: 2px;
  bottom: -1px;
  top: 2px;
  background-color: #fff;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 50%;
}

.switch-toggle-btn input:checked + .slider {
  background-color: #2ecd6c;
}

.switch-toggle-btn input:checked + .slider-disabled {
  background-color: #aaeac3 !important;
}

.switch-toggle-btn input:focus + .slider {
  box-shadow: 0 0 1px #2ecd6c;
}

.switch-toggle-btn input:checked + .slider:before {
  -webkit-transform: translateX(75px);
  -ms-transform: translateX(75px);
  transform: translateX(75px);
}

.switch-toggle-btn .text {
  color: white;
}

.switch-toggle-btn .text:after {
  position: absolute;
  top: 2px;
  right: 15px;
  content: "Disabled";
  -webkit-transition: opacity 0.5s ease-in-out;
  -moz-transition: opacity 0.5s ease-in-out;
  transition: opacity 0.5s ease-in-out;
}
.switch-toggle-btn .text:before {
  position: absolute;
  top: 2px;
  left: 15px;
  content: "Enabled";
  -webkit-transition: opacity 0.5s ease-in-out;
  -moz-transition: opacity 0.5s ease-in-out;
  transition: opacity 0.5s ease-in-out;
}

.switch-toggle-btn input + .slider + .text:after {
  opacity: 1;
}
.switch-toggle-btn input + .slider + .text:before {
  opacity: 0;
}

.switch-toggle-btn input:checked + .slider + .text:after {
  opacity: 0;
}

.switch-toggle-btn input:checked + .slider + .text:before {
  opacity: 1;
}
button.resource-close {
  position: relative;
  left: 7px;
  bottom: 10px;
  font-size: 18px;
}
.success-message {
  height: 47px;
  text-align: center;
  font-size: 16px;
  line-height: 2;
  color: #666669;
  font-family: "RobotoRegular";
}
</style>
